import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const ChatOutlineIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-chat-outline', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.05357 3.49991C4.70929 3.49991 4.42857 3.80964 4.42857 4.18986V9.75827C4.42857 10.1392 4.70929 10.449 5.05357 10.449H9.24286L11.5714 12.4371V4.18986C11.5714 3.80964 11.2907 3.49991 10.9464 3.49991H5.05357ZM11.6179 14C11.3107 14 11.0071 13.8898 10.755 13.6738L8.735 11.9489H5.05357C3.92143 11.9489 3 10.9657 3 9.75827V4.18986C3 2.98244 3.92143 2 5.05357 2H10.9464C12.0786 2 13 2.98244 13 4.18986V12.5323C13 13.1068 12.6957 13.6145 12.2071 13.859C12.0179 13.9528 11.8171 14 11.6179 14Z'
      />
    </svg>
  );
};

export default ChatOutlineIcon;
